export default {
    'cart.global.withDph': 's DPH',

    'contact.email': 'info@vsevyhodne.cz',
    'contact.phoneNumber': '+420 585 311 666',
    'contact.openingHours': 'Po-Pá 7:00 - 14:00',

    'product.showMoreBtn': 'Zobrazit více',
    'product.cartBtn': 'Přidat',

    'newsletter.title': 'Získejte výhody vždy jako první!',
    'newsletter.btn': 'Přihlásit se k odběru',

    'input.emailPlaceholder': 'Váš e-mail',

    'header.mobileMenuHeading': 'Hlavní kategorie',
    'header.otherCategories': 'Ostatní',

    'category.loading': 'Zobrazit další',
    'category.availability': 'Skladem',

    'detail.brand': 'Výrobce:',
    'detail.expirationDate': 'Datum expirace',

    'login.title': 'Přihlášení k účtu',

    'cart.showCart': 'Nákupní košík',

    'advancedOrder.productsHeader': 'Ostatní si také zakoupili',

    'cart.step1.next': 'Vybrat dopravu a platbu',
    'cart.step1.addCoupon': 'Přidat',
    'cart.step1.addCouponTitle': 'Slevový kupón',
    'cart.step1.gift': 'Dárek',
    'cart.step1.giftFree': 'Dárek zdarma!',

    'cart.step2.nextStepBtn': 'Doplnit informace o vás',

    'cart.step3.loginLink': 'Přihlásit se k účtu',

    'cart.thankYouPage.heading': 'Objednávka byla úspěšně odeslána',
    'cart.thankYouPage.thankYouOrderNumber': 'Děkujeme za Vaši objednávku číslo',
    'cart.thankYouPage.orderNumber': 'Číslo objednávky',

    'cart.emptyCart.backToShop': 'Zpět do obchodu',
    'cart.emptyCart.emptyCart': 'Váš košík je prázdný',
    'cart.emptyCart.emptyCartSubtitle': 'Váš košík čeká na své první objevy – podívejte se na naši nabídku!',

    'cart.step1.orderSummary': 'Rekapitulace objednávky',

    'reviews.name': 'Ověřený zákazník',

    'contact.title': 'Kontaktujte nás',

    'terms.text':
        '    <a href="/obchodni-podminky/">Obchodní podmínky</a> a <a href="/podminky-ochrany-osobnich-udaju/">podmínky ochrany osobních údajů</a>',
}
